import Component from '../colorz/Component';

import device from '../colorz/utils/device';

module.exports = class Newsletter extends Component {
  onInit( el, args) {
    // Initializations
    this.listenChange = this.listenChange.bind( this );

    this.el = el;
    this.input = this.el.querySelectorAll('.js-input');
    this.label = this.el.querySelectorAll('.js-label');
  }

  onReady() {
    for (var i = 0; i < this.input.length; i++) {
      this.input[i].addEventListener( 'focusout', this.listenChange );
    }
  }

  listenChange() {
    for (var i = 0; i < this.input.length; i++) {
      if( this.input[i].value != '' ) {
        this.el.classList.add('transition-on');
      } else {
        this.el.classList.remove('transition-on');
      }
    }
  }
}